(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');

  app.service('optionsApi', [
    '$http',
    '$q',
    function($http, $q) {

      this.getIab = function(extended,withSubCats,showId) {
        var url = '/demandmgr/options/iab';
        if (extended){
          url += "?extended=true";
        }

          if (withSubCats){
              url += extended ? '&' : '?';
              url += "withSubCats=true";
          }

          if (showId){
              url += extended || withSubCats ? '&' : '?';
              url += "showId=true";
          }

        return $q(function(resolve, reject) {
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };

      this.isUseCdp = function() {
        return true;
      };

      this.getGoals = function() {
        var url = '/demandmgr/options/goals';
        return $q(function(resolve, reject) {
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };

      this.getDelivery = function() {
        var url = '/demandmgr/options/delivery';
        return $q(function(resolve, reject) {
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };

      this.getOs = function() {
        var url = '/demandmgr/options/os';
        return $q(function(resolve, reject) {
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };

      this.getLangs = function() {
        var url = '/demandmgr/options/lang';
        return $q(function(resolve, reject) {
          $http.get(url).then(
              // success
              function(res) {
                resolve(res.data);
              },
              // error
              function(res) {
                reject();
              }
          );
        });
      };

      this.getDsperformanceMode = function() {
        var url = '/demandmgr/options/dsperformance-mode';
        return $q(function(resolve, reject) {
          $http.get(url).then(
            /* success */function(res) { resolve(res.data); },
            /* error */function(res) { reject(); }
          );
        });
      };

      this.getDevices = function() {
        var url = '/demandmgr/options/device';
        return $q(function(resolve, reject) {
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };

      this.getSpeed = function() {
        var url = '/demandmgr/options/speed';
        return $q(function(resolve, reject) {
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };

      this.getDayHour = function() {
        var url = '/demandmgr/options/day-hour';
        return $q(function(resolve, reject) {
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };

      this.getWeekDay = function() {
        var url = '/demandmgr/options/week-day';
        return $q(function(resolve, reject) {
          $http.get(url).then(
              // success
              function(res) {
                resolve(res.data);
              },
              // error
              function(res) {
                reject();
              }
          );
        });
      };


      this.getCountries = function() {
        var url = '/demandmgr/options/countries';

        return $q(function(resolve, reject) {
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };

        this.getRegions = function() {
            var url = '/demandmgr/options/regions';

            return $q(function(resolve, reject) {
                $http.get(url).then(
                    // success
                    function(res) {
                        resolve(res.data);
                    },
                    // error
                    function(res) {
                        reject();
                    }
                );
            });
        };

        this.getLeadTypes = function() {
            var url = '/demandmgr/options/leadTypes';

            return $q(function(resolve, reject) {
                $http.get(url).then(
                    // success
                    function(res) {
                        resolve(res.data);
                    },
                    // error
                    function(res) {
                        reject();
                    }
                );
            });
        };

      this.getCreativeTypes = function() {
        var url = '/demandmgr/options/creative-types';
        return $q(function(resolve, reject) {
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function() {
              reject();
            }
          );
        });
      };

      this.getInventoryCreativeTypes = function() {
        var url = '/demandmgr/options/inventory-creative-types';
        return $q(function(resolve, reject) {
          $http.get(url).then(
              // success
              function(res) {
                resolve(res.data);
              },
              // error
              function() {
                reject();
              }
          );
        });
      };


      this.getCampaignTypes = function() {
        var url = '/demandmgr/options/campaign-types';
        return $q(function(resolve, reject) {
          $http.get(url).then(
              // success
              function(res) {
                resolve(res.data);
              },
              // error
              function() {
                reject();
              }
          );
        });
      };


      this.getCreativeWeights = function() {
        var url = '/demandmgr/options/creative-weights';

        return $q(function(resolve, reject) {
          $http.get(url).then(
            function(res) { resolve(res.data); }, // success
            function(res) { reject(); }, // error
          );
        });
      };

      this.getNativeDicts = function() {
        var url = '/demandmgr/options/nativeDicts';

        return $q(function(resolve, reject) {
          $http.get(url).then(
              function(res) { resolve(res.data); }, // success
              function(res) { reject(); }, // error
          );
        });
      };


      this.getAccountManagers = function() {
        var url = '/users-list?roleGroup=demandMgr';

        return $q(function(resolve, reject) {
          $http.get(url).then(
              function(res) {
                resolve(res.data);
              },
              function(res) {
                reject({ code: res.data.errorCode, message: res.data.message });
              }
          );
        });
      };

    },
  ]);
})(window.angular);
